import postprocessing_VERT from './shaders/postprocessing_VERT.glsl';
import addMaterial_FRAG from './shaders/addMaterial_FRAG.glsl';
import { DataArrayTexture, NoBlending, ShaderMaterial, Uniform } from 'three';

export class AddMaterial extends ShaderMaterial {
    constructor(arrayTexture: DataArrayTexture) {
        super({
            name: 'AddMaterial',
            uniforms: {
                texArray: new Uniform(arrayTexture),
            },
            blending: NoBlending,
            toneMapped: false,
            depthWrite: false,
            depthTest: false,
            fragmentShader: addMaterial_FRAG,
            vertexShader: postprocessing_VERT,
        });
    }
}
